export default function calculatePetTotalPrice(pet, insurance_price) {
  const prevent_price = pet.plan ? pet.plan.cost : 0.0;
  return insurance_price + prevent_price;
}
